function queryToJson(url) {
    if (!url) {
        url = window.location.href;
    }
    var query = url.substr(url.lastIndexOf('?') + 1),
        result = {}, 
        kv, key, value, item;
    if(query != url && query.indexOf('&') == -1) {
        query += '&';
    }
    query = query.split('#')[0];
    query.split('&').forEach(function(param) {
        if(param) {
            kv = param.split('=');
            key = kv[0];
            value = kv[1];
            item = result[key];
            if(typeof item === 'undefined') {
                result[key] = value;
            } else if(Object.prototype.toString.call(item) === '[object Array]') {
                item.push(value);
            } else {
                result[key] = [item, value];
            }
        }
    });
    return result;
}

function getDomains (str) {
    str = str || window.location.hostname;
    return str.match(/([a-z0-9][a-z0-9\-]*?\.(?:com|cn|net|org|gov|info|la|cc|co)(?:\.(?:cn|jp))?)$/i) || [];
}


/* 获取分站前缀 */
function getApiPrefix() {
    let domain = document.domain;
    let reg = /^(?=^.{3,255}$)([a-zA-Z0-9][-a-zA-Z0-9]{0,62})(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
    let arr = domain.match(reg) || [];
    if(arr.length >= 2 && arr[1].indexOf('www') == -1) {
        return (arr[1] || '').replace('-dev', '').replace('-test', '');
    }
    return '';
}

/* 替换占位符如: stringFormat('{0}/world', 'hello') 结果为：hello/world */
function stringFormat() {
    if (arguments.length == 0)
        return null;
    var value = arguments[0];
    for (var i = 1, count = arguments.length; i < count; i++) {
        var pattern = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
        value = value.replace(pattern, arguments[i]);
    }
    return value
}

/*
 * 保存二进制文件流为文件
 * @param {String} fileName 文件名
 * @param {Blob} blobData 二进制文件类
 */
function saveBlobFile(fileName, blobData) {
    const URL = window.URL || window.webkitURL;
    let blob = new Blob([blobData]);
    let bloburl = URL.createObjectURL(blob);
    let anchor = document.createElement("a");
    if ('download' in anchor) {
        anchor.style.visibility = "hidden";
        anchor.href = bloburl;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        let evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, true);
        anchor.dispatchEvent(evt);
        document.body.removeChild(anchor);
    } else if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
    } else {
        //TODO
         //防止刷新当前页面   新打开一个标签  window.open(bloburl)
        location.href = bloburl; 
    }
}

/**
 * 防抖节流
 * @param {*} callback 回调
 * @param {*} delay 等待时间
 * @param {*} context this指针
 * @param {Boolean} isElapsed 是否等待上一次
 * @returns {Function}
 */
function throttle(callback, delay, context, isElapsed) {
    let timer = null;
    let lastRun = 0;
    return function() {
        if(timer) {
            if(isElapsed) { // 等待上一次
                return;
            } else {
                clearTimeout(timer) ;
                timer = null;
            }
        }
        let elapsed = Date.now() - lastRun;
        let args = arguments;
        if(isElapsed && elapsed >= delay) {
            runCallback();
        } else {
            timer = setTimeout(runCallback, delay);
        }

        // 执行回调
        function runCallback() {
            lastRun = Date.now();
            timer = false;
            callback.apply(context, args);
        }
    }
}


export {
    getDomains,
    getApiPrefix,
    queryToJson,
    stringFormat,
    saveBlobFile,
    throttle
}
